import { useParams, Link } from 'react-router-dom';

const COPY = {
  terms: { title: 'Terms', body: 'Placeholder terms of service. Final legal copy pending review. Use Ghostie at your own discretion. By booking, you agree to all listed policies including safety, cancellation, and paranormal disclaimer.' },
  privacy: { title: 'Privacy Policy', body: 'Placeholder privacy policy. We collect booking, contact, and emergency contact data for the purpose of fulfilling private mystery meetups. Final legal copy pending review.' },
  safety: { title: 'Safety Guidelines', body: 'Public meeting points only. No illegal access. No trespassing. No dangerous locations. Customers must follow Ghostie instructions and local laws. Emergency contact required.' },
  cancellation: { title: 'Cancellation Policy', body: 'Free cancellation up to 72 hours before the meetup. If Ghostie cannot find a suitable host, we first offer a credit for a new date/city. If no acceptable alternative is available, we refund.' },
  paranormal: { title: 'Paranormal Disclaimer', body: 'We do not guarantee paranormal activity. Ghostie meetups focus on folklore, mystery, dark travel and atmosphere, not on supernatural events. Final legal copy pending review.' },
  'host-guidelines': { title: 'Host Guidelines', body: 'Ghosties are not professional tour guides. Hosts must follow safety rules, respect customers, maintain public meeting points, and avoid any illegal or unsafe locations.' },
};

export default function Legal() {
  const { slug } = useParams();
  const c = COPY[slug] || { title: 'Page', body: '' };
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <Link to="/" className="link-soft text-sm">← Home</Link>
      <h1 className="text-4xl font-heading font-semibold mt-3 mb-2">{c.title}</h1>
      <div className="badge-cozy mb-6">Pending legal review</div>
      <p className="text-[#a3a3a3] leading-relaxed whitespace-pre-line">{c.body}</p>
    </div>
  );
}
